module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', {
    staticClass: "push_sidebar widget-name"
  }, [_c('div', {
    ref: "modalInfo",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.datosPlato) ? _c('h4', [_c('b', {
    staticClass: "text-primary"
  }, [_vm._v("Información nutricional de " + _vm._s(_vm.datosPlato.nombre))])]) : _vm._e()]), _vm._v(" "), (_vm.datosPlato && _vm.datosPlato.receta) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.datosPlato.receta.edamam.totals) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('graph-pie', {
    attrs: {
      "width": 350,
      "height": 350,
      "padding-top": 50,
      "padding-right": 50,
      "padding-bottom": 75,
      "padding-left": 50,
      "values": _vm.nutritionalValues,
      "names": _vm.nutritionalLabels,
      "active-event": 'click',
      "show-text-type": 'outside',
      "data-format": _vm.dataFormat,
      "colors": ['#93A512', '#74A9B3', '#F28893'],
      "shape": 'donut',
      "show-total-value": true
    }
  }, [_c('note', {
    attrs: {
      "text": _vm.nutritionalTotal,
      "size": 20,
      "color": '#66277b'
    }
  }), _vm._v(" "), _c('legends', {
    attrs: {
      "names": _vm.nutritionalLabels
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "names": _vm.nutritionalLabels
    }
  })], 1)], 1)]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('header', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-8"
  }, [_c('div', {
    staticClass: "date-picker"
  }, [_c('div', {
    ref: "calendar_menu",
    staticClass: "date-picker-dates owl-carousel"
  }, _vm._l((_vm.dias), function(dia) {
    return _c('div', {
      key: dia,
      staticClass: "item",
      class: {
        current: dia === _vm.diaActivo
      }
    }, [(_vm.pedidosProgramados[dia]) ? _c('i', {
      staticClass: "highlight fa fa-check-circle",
      attrs: {
        "data-position": "bottom",
        "id": 'tip' + dia,
        "data-toggle": "tooltip",
        "rel": "tooltip",
        "data-placement": "bottom",
        "data-original-title": "PEDIDOS PROGRAMADOS",
        "title": "PEDIDOS PROGRAMADOS"
      },
      on: {
        "mouseover": function($event) {
          _vm.mostrarTooltip('tip' + dia)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "cutoff-date-option",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setDia(dia)
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticClass: "day-of-week mobile"
    }, [_vm._v(_vm._s(_vm._f("diaNombreMobile")(dia)))]), _vm._v(" "), _c('div', {
      staticClass: "day-of-week desktop"
    }, [_vm._v(_vm._s(_vm._f("diaNombreDesktop")(dia)))]), _vm._v(" "), _c('div', {
      staticClass: "day-of-month"
    }, [_vm._v(_vm._s(_vm._f("diaNumero")(dia)))])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm col-md-3 col-lg-2 head-actions-right"
  }, [_c('div', {
    staticClass: "pull-right menu-print"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.imprimirMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-print"
  })])])])])])]), _vm._v(" "), (_vm.menuActivo && _vm.asignacionActiva && _vm.precioCombo) ? _c('div', {
    staticClass: "main-alert"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('span', {}, [_vm._v("PUEDES PEDIR " + _vm._s(_vm.reglasATexto) + " POR UN VALOR DE $" + _vm._s(_vm.precioCombo.precio) + "/DÍA. LA EMPRESA ABONA EL " + _vm._s(_vm.subsidioDia) + "% DEL VALOR DE TUS PEDIDOS")]), _vm._v(" "), _c('span', {
    staticClass: "hide"
  }, [_vm._v("PUEDES PEDIR TU PLATO PRINCIPAL + POSTRE POR UN VALOR DE $75/DÍA. LA EMPRESA ABONARÁ EL 50% DEL VALOR DE TUS PEDIDOS DE TU RECIBO DE SUELDO")])]), _vm._v(" "), _vm._m(2)])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "menu-section menu-content"
  }, [(_vm.cargando) ? _c('div', {
    staticClass: "container"
  }, _vm._l((3), function(n) {
    return _c('div', {
      key: n,
      staticClass: "col-xs-12 col-sm-4"
    }, [_vm._m(3, true)])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.asignacionActiva && _vm.carrito.length === 0) ? _c('ul', {
    staticClass: "nav nav-pills text-center center-block",
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "20px"
    }
  }, _vm._l((_vm.proveedores), function(proveedor) {
    return _c('li', {
      class: {
        active: proveedor._id === _vm.asignacionActiva._id
      },
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      staticClass: "btn btn-outline",
      staticStyle: {
        "height": "32px"
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setProveedorActivo(proveedor._id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(proveedor.combo.nombre) + "\n              ")])])
  })) : _vm._e()]), _vm._v(" "), (!_vm.pedidosProgramados[_vm.diaActivo] || _vm.user.roles[0] === 'admincliente') ? [(_vm.menusMostrar.categorias) ? _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.menusMostrar.categorias), function(categoria, idxCategoria) {
    return _c('section', {
      key: categoria._id,
      staticClass: "menu-section"
    }, [_c('div', {
      staticClass: "menu-section-head"
    }, [_vm._v(_vm._s(categoria.nombre) + " "), (_vm.menusMostrar.enabled) ? _c('small', [_vm._v("(" + _vm._s(_vm.itemsCarritoCategoria(_vm.menuActivo.fecha, categoria._id)) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.platosAgrupadosCategoria[categoria._id].length > 0) ? _c('ul', {
      staticClass: "menu-items row"
    }, _vm._l((_vm.platosAgrupadosCategoria[categoria._id]), function(plato, idxListItem) {
      return _c('li', {
        key: plato._id,
        staticClass: "menu-item"
      }, [(plato.proveedor) ? _c('div', {
        ref: 'plato' + idxCategoria + ' ' + idxListItem,
        refInFor: true,
        staticClass: "item-img-container",
        class: {
          sin: plato.cantidad === 0
        },
        on: {
          "mouseover": function($event) {
            _vm.mostrarHover('plato' + idxCategoria + ' ' + idxListItem, plato.cantidad)
          },
          "mouseleave": function($event) {
            _vm.esconderHover('plato' + idxCategoria + ' ' + idxListItem, plato.cantidad)
          }
        }
      }, [_c('div', {
        staticClass: "item-img photo",
        staticStyle: {
          "background-size": "cover",
          "background-position": "center"
        },
        style: ({
          backgroundImage: 'url(' + plato.urlThumb + ')',
          opacity: _vm.menusMostrar.enabled ? 1 : 0.4
        }),
        attrs: {
          "source": plato.urlThumb
        }
      }, [_c('div', {
        staticClass: "item-caption"
      }, [_c('div', {
        staticClass: "item-description"
      }, [_c('a', {
        staticClass: "item-link"
      }, [_c('p', {
        staticClass: "item-name-desc open"
      }, [_vm._v(_vm._s(plato.nombre))]), _vm._v(" "), _c('p', {
        staticClass: "item-subname-desc"
      }, [_vm._v(_vm._s(plato.descripcion))]), _vm._v(" "), _c('p', {
        staticClass: "item-desc"
      }, [_vm._v(_vm._s(plato.observaciones))])])]), _vm._v(" "), _c('div', {
        staticClass: "item-quantity",
        class: {
          hide: plato.cantidad === 0
        }
      }, [_c('div', {
        staticClass: "alert-add"
      }, [_vm._v("AGREGADO A TU LISTA!")]), _vm._v(" "), _c('div', {
        staticClass: "quantity-actions"
      }, [_c('div', {
        staticClass: "quantity"
      }, [_c('a', {
        staticClass: "decrease",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.disminuir(_vm.menusMostrar.fecha, plato)
          }
        }
      }, [_vm._v("–")]), _vm._v(" "), _c('span', {
        staticClass: "qty-value"
      }, [_vm._v(_vm._s(plato.cantidad))]), _vm._v(" "), _c('a', {
        staticClass: "increase",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.agregarAlCarrito(_vm.diaActivo, plato)
          }
        }
      }, [_vm._v("+")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-details"
      }, [_c('h2', {
        staticClass: "item-name open",
        class: {
          disabled: !_vm.menusMostrar.enabled
        }
      }, [_vm._v(_vm._s(plato.nombre))]), _vm._v(" "), _c('footer', [_c('div', {
        staticClass: "right-actions"
      }, [(_vm.menusMostrar.enabled) ? _c('span', {
        staticClass: "actions"
      }, [_c('b', {
        staticClass: "pull-left"
      }, [_vm._v(_vm._s(_vm.disponibles(_vm.diaActivo, plato)))]), _vm._v(" "), (_vm.puedeAgregar(_vm.diaActivo, plato) && plato.cantidad === 0) ? _c('button', {
        staticClass: "btn btn-sm btn-outline add-to-cart",
        attrs: {
          "title": "Agregar a mis pedidos"
        },
        on: {
          "click": function($event) {
            _vm.agregarAlCarrito(_vm.diaActivo, plato)
          }
        }
      }, [_vm._v("\n                        AGREGAR \n                      ")]) : _vm._e(), _vm._v(" "), (plato.cantidad > 0) ? _c('button', {
        staticClass: "btn btn-sm btn-outline btn-quit add-to-cart",
        attrs: {
          "title": "Quitar de mis pedidos"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.disminuir(_vm.menusMostrar.fecha, plato)
          }
        }
      }, [_vm._v("\n                          QUITAR\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "dietary-tag"
      }, [(plato.aptoCeliacos) ? _c('i', {
        staticClass: "icon-celiac",
        attrs: {
          "data-toggle": "tooltip",
          "rel": "tooltip",
          "data-placement": "top",
          "data-original-title": "APTO CELÍACOS",
          "title": "APTO CELÍACOS"
        }
      }) : _vm._e(), _vm._v(" "), (plato.picante) ? _c('i', {
        staticClass: "icon-spice",
        attrs: {
          "data-toggle": "tooltip",
          "rel": "tooltip",
          "data-placement": "top",
          "data-original-title": "PICANTE",
          "title": "PICANTE"
        }
      }) : _vm._e(), _vm._v(" "), (plato.vegetariano) ? _c('i', {
        staticClass: "icon-vegetarian",
        attrs: {
          "data-toggle": "tooltip",
          "rel": "tooltip",
          "data-placement": "top",
          "data-original-title": "VEGETARIANO",
          "title": "VEGETARIANO"
        }
      }) : _vm._e(), _vm._v(" "), (plato.vegano) ? _c('i', {
        staticClass: "icon-vegan",
        attrs: {
          "data-toggle": "tooltip",
          "rel": "tooltip",
          "data-placement": "top",
          "data-original-title": "100% VEGANO",
          "title": "100% VEGANO"
        }
      }) : _vm._e(), _vm._v(" "), (plato.receta && plato.receta.edamam && plato.receta.edamam.totals) ? _c('span', {
        staticClass: "nutritional-info",
        attrs: {
          "data-toggle": "tooltip",
          "rel": "tooltip",
          "data-placement": "top",
          "data-original-title": "Ver Información nutricional",
          "title": "Ver Información nutricional"
        },
        on: {
          "click": function($event) {
            _vm.showNutritionalInfo(plato)
          }
        }
      }, [_vm._v("\n                          Calorias: " + _vm._s(plato.receta.edamam.totals.totalCal) + "\n                        ")]) : _vm._e()])])])])])
    })) : [_c('div', {
      staticClass: "text-center center-block placeholder"
    }, [_c('h1', [_vm._v(" No hay platos de la categoría para esta fecha")])])]], 2)
  }), _vm._v(" "), (_vm.dias.length > 0) ? _c('div', {
    staticClass: "nav-week-footer"
  }, [(_vm.idxDia > 0) ? _c('a', {
    staticClass: "nwf-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setDia(_vm.dias[_vm.idxDia - 1])
      }
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatFechaNavegador")(_vm.dias[_vm.idxDia - 1])))])]) : _vm._e(), _vm._v(" "), (0 < (_vm.dias.length - 1)) ? _c('a', {
    staticClass: "nwf-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setDia(_vm.dias[_vm.idxDia + 1])
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatFechaNavegador")(_vm.dias[_vm.idxDia + 1])))]), _vm._v(" "), _c('i', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e()]) : _vm._e()], 2) : _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "text-center center-block"
  }, [_vm._v("No hay platos para esta fecha")]), _vm._v(" "), (_vm.dias.length > 0) ? _c('div', {
    staticClass: "nav-week-footer"
  }, [(_vm.idxDia > 0) ? _c('a', {
    staticClass: "nwf-left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setDia(_vm.dias[_vm.idxDia - 1])
      }
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatFechaNavegador")(_vm.dias[_vm.idxDia - 1])))])]) : _vm._e(), _vm._v(" "), (0 < (_vm.dias.length - 1)) ? _c('a', {
    staticClass: "nwf-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setDia(_vm.dias[_vm.idxDia + 1])
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatFechaNavegador")(_vm.dias[_vm.idxDia + 1])))]), _vm._v(" "), _c('i', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e()]) : _vm._e()])] : [_c('h1', {
    staticClass: "text-center center-block"
  }, [_vm._v("Ya tienes pedidos para esta fecha")])]], 2), _vm._v(" "), (_vm.user.roles[0] === 'admincliente') ? _c('div', {
    staticClass: "box-text centered only-admin"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_vm._v("¿Deseas agregar una persona a tu cuenta de administrador?")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-fill margin-bottom-30",
    attrs: {
      "to": "/newuser"
    }
  }, [_vm._v("CREAR CUENTA")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.menuActivo) ? _c('div', {
    ref: "menuDia",
    staticClass: "hidden"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Menú del día " + _vm._s(_vm._f("formatFechaNavegador")(_vm.diaActivo)) + " en andalepide")]), _vm._v(" "), _vm._l((_vm.menuActivo.categorias), function(categoria, idxCategoria) {
    return _c('div', [_c('h4', {
      staticStyle: {
        "text-decoration": "underline"
      }
    }, [_vm._v(_vm._s(categoria.nombre))]), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((_vm.filtroCategoria(categoria)), function(plato, idxListItem) {
      return _c('li', {
        key: plato._id
      }, [_c('span', [_vm._v(_vm._s(plato.nombre))]), _vm._v(" "), _vm._m(4, true)])
    }))])
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visible-lg col-lg-2 head-actions-left"
  }, [_c('div', {
    staticClass: "dropdown pull-left change-city"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center center-block"
  }, [_c('div', {
    staticClass: "btn-group botonera"
  }, [_c('a', {
    staticClass: "btn btn-link dietary-tag"
  }, [_vm._v("Todos")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link dietary-tag"
  }, [_c('i', {
    staticClass: "icon-vegan"
  }), _vm._v(" Vegano")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link dietary-tag"
  }, [_c('i', {
    staticClass: "icon-vegetarian"
  }), _vm._v(" Vegetariano")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link dietary-tag"
  }, [_c('i', {
    staticClass: "icon-spice"
  }), _vm._v(" Picante")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-link dietary-tag"
  }, [_c('i', {
    staticClass: "icon-celiac"
  }), _vm._v(" Sin gluten")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mocka-container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "mocka-heading"
  }), _vm._v(" "), _c('span', {
    staticClass: "mocka-media",
    staticStyle: {
      "width": "85%"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "mocka-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "mocka-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "mocka-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aae6abe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/Menu.vue
// module id = 1158
// module chunks = 5